import React from 'react';

import { PageHeader } from 'antd';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import ChargingProfileForm from '../organisms/ChargingProfile/ChargingProfileForm';

const ChargingProfileCreatePageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;

const ChargingProfileCreatePage = () => {
  const history = useHistory();
  const initialValues = {
    description: '',
    currentLimitDefault: '',
    intervals: [],
  };

  return (
    <ChargingProfileCreatePageWrapper>
      <PageHeader
        className='site-page-header'
        onBack={() => history.goBack()}
        title='Criando perfil de recarga'
      />
      <ChargingProfileForm initialValues={initialValues} type='create' />
    </ChargingProfileCreatePageWrapper>
  );
};

export default ChargingProfileCreatePage;
